import React, { useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
// import RevenueChart from "./DashboardCharts/EstimatedRevenue";
// import GenerationChart from "./DashboardCharts/GenerationAndAwards";
import RevenueTable from "./ChartsSetup/EstimatedRevenueTable";
// import VolumeChart from "./DashboardCharts/RDVolumeLineChart";
import VolumeTable from "./ChartsSetup/VolumeTable";
import OutagesChart from "./DashboardCharts/OutagesLineChart";
import OutagesTable from "./DashboardCharts/OutagesTable";
// import PriceChart from "./DashboardCharts/PriceTabChart";
import PriceTable from "./ChartsSetup/PriceTable";
// import { FaRegFilePdf } from "react-icons/fa6";
// import { TbFileExcel } from "react-icons/tb";
// import { FaRegCopy } from "react-icons/fa";
// import { BsFiletypeCsv } from "react-icons/bs";
import AssetRevenuePage from "./AssetRevenue/AssetRevenuePage";
import AssetChart from "./ChartsSetup/RevenueChartSetup";
import Volumechart from "./ChartsSetup/VolumeChartSetup";
import PriceDashboard from "./ChartsSetup/PriceChartSetup";
import VolumeDeltaChart from "./ChartsSetup/VolumeDelataSetup";
import DateDisplay from "./ConfigCharts/useFormattedDate";
import DateDisplayWithPicker from "./ConfigCharts/DateDisplayWithPicker";
// import PriceSummaryCard from "./TabSection/PriceSummaryCard";
import PriceSummaryCard from "./TabSection/PriceSummaryCard";


interface ChartTabsProps {
  tabsConfig: {
    tabs: {
      label: string;
      displayLabel?: string;
      // charts: { key: string; label: string; }[];
      charts: {
  key: string;
  label: string;
  dateDisplay?: React.ReactNode;
}[];
      tables: { key: string; label: string }[];
    }[];
  };
  activeTab: number; 
  assetSlug?: string; 
  refreshCounter?: number;
}

const ChartTabs: React.FC<ChartTabsProps> = ({  tabsConfig,
  activeTab
 }) => {
  // const [activeTab, setActiveTab] = useState(0);
  const [visibility, setVisibility] = useState<Record<string, boolean>>({});
 const navigate = useNavigate();
  const slugify = (label: string) => label.toLowerCase().replace(/\s+/g, "-");
  const { assetSlug, tab } = useParams<{ tab: string; assetSlug: string }>();

  // tabsConfig.tabs is already filtered by AssetDashboard — use directly
  const visibleTabs = tabsConfig.tabs;

  // Ensure activeTab index is valid
  const safeActiveTab = Math.min(activeTab, visibleTabs.length - 1);
 
  const chartComponents: { [key: string]: React.ReactNode } = {
    RevenueChart: <AssetChart />, 
    GenerationChart: <VolumeDeltaChart />, 
    VolumeChart: <Volumechart setVisibility={setVisibility} visibility={visibility}  />, 
    OutagesChart: <OutagesChart />, 
    PriceChart: <PriceDashboard  setVisibility={setVisibility} visibility={visibility} />,
    //  RevenueWaterfall: <AssetRevenuePage />,
  //   RevenueWaterfall: (
  // <AssetRevenuePage
  //   key={`${assetSlug}-${refreshCounter}`}
  // />
  RevenueWaterfall: (
  <AssetRevenuePage />
),

  };

  const tableComponents: {
    [key: string]: (props: { title: string }) => React.ReactNode;
  } = {
    VolumeTable: ({ title }) => (
      <VolumeTable
        title={title}
        visibility={visibility}
        setVisibility={setVisibility}
      />
    ),
    PriceTable: ({ title }) => (
      <PriceTable
        title={title}
        visibility={visibility}
        setVisibility={setVisibility}
      />
    ),
    RevenueTable: ({ title }) => <RevenueTable title={title} />,
    OutagesTable: () => <OutagesTable  />,
  };
  return (
    <div className="m-[10px] md:m-[45px] shadow-[0_4px_10px_rgba(0,0,0,0.1)] rounded-[15px] overflow-hidden border-l-[2px] border-r-[2px] border-b-[2px] border-[#EAE7FF]">
      <div className="flex justify-start bg-[#F7F7FF] flex-wrap">
        {visibleTabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => {
              navigate(`/asset-dashboard/${slugify(tab.label)}/${assetSlug}`);
            }}
            
            className={`px-3 sm:px-4 md:px-8 py-2 sm:py-3 md:py-[10px] text-sm sm:text-base md:text-[20px] rounded-t-[10px] transition-all  ${
              activeTab === index
                ? "bg-white text-[#FF2C2C] font-bold shadow-[0_6px_15px_rgba(0,0,0,0.15)] border-t-[2px] border-l-[2px] border-r-[2px] border-[#EAE7FF] mr-2 sm:mr-4 md:mr-[10px]"
                : " bg-[#e3e5f2] text-gray-600 mr-2 sm:mr-4 md:mr-[10px]"
            }`}
          >
            {/* {tab.label}   */}
          {tab.displayLabel || tab.label}
          </button>
        ))}
      </div>

      {/* Charts and Tables Content */}
      <div className="bg-white p-1 md:p-5 border border-[#EAE7FF]">
        <div className="bg-[#EAE7FF] p-2 md:p-5 rounded-lg">
        {visibleTabs[safeActiveTab]?.charts.map((chart) => (
          chartComponents[chart.key] && (
            <div
            key={`${visibleTabs[safeActiveTab]?.label}-${chart.key}`}
            className="border border-gray-300 rounded-xl bg-white mb-6 p-3 md:p-5"
          >
            <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
              {/* Label + Date */}
              <div className="flex flex-col sm:flex-row sm:items-start">
                <h1 className="text-sm md:text-xl font-bold text-gray-600 sm:pt-1">
                  {chart.label}
                </h1>
                <span className="text-gray-500 sm:ml-4 mt-1 sm:mt-0">
                  {/* <DateDisplay /> */}
                  {chart.dateDisplay || <DateDisplay />}
                </span>
              </div>
            </div>
          
            {/* Chart/Table data goes below on small screens */}
            <div className="w-full">{chartComponents[chart.key]}</div>
          </div>
          
          )
        ))}

{
  visibleTabs[safeActiveTab]?.label === "Price" && (
    <PriceSummaryCard visibility={visibility} />
  )
}
{/* {visibleTabs[safeActiveTab]?.tables.map((table, index) => {
  const TableComponent = tableComponents[table.key];
  return (
    TableComponent && (
      <div key={index} className="border border-gray-300 rounded-xl bg-white mb-2 ">
        {TableComponent({ title: table.label })}
      </div>
    )
  );
})} */}
{visibleTabs[safeActiveTab]?.label !== "Asset Revenue" &&
  visibleTabs[safeActiveTab]?.tables.map((table) => {
    const TableComponent = tableComponents[table.key];
    return (
      TableComponent && (
        <div key={`${visibleTabs[safeActiveTab]?.label}-${table.key}`} className="border border-gray-300 rounded-xl bg-white mb-2 ">
          {TableComponent({ title: table.label })}
        </div>
      )
    );
  })}

        </div>
      </div>
    </div>
  );
};

export default ChartTabs;
